import { BaggageDirection } from '../BaggageList/types';
export const convertBaggageOnBaggageItem = (baggages, selectedServices, segments) => {
    var _a, _b, _c;
    const firstBaggage = baggages[0];
    const minPrice = {
        amount: ((_a = firstBaggage.price) === null || _a === void 0 ? void 0 : _a.amount) * ((_b = firstBaggage.segmentIds[0]) === null || _b === void 0 ? void 0 : _b.length),
        currency: (_c = firstBaggage.price) === null || _c === void 0 ? void 0 : _c.currency
    };
    baggages === null || baggages === void 0 ? void 0 : baggages.forEach(baggage => {
        baggage.segmentIds.forEach(segmentId => {
            if (!minPrice.amount || baggage.price.amount * segmentId.length < (minPrice === null || minPrice === void 0 ? void 0 : minPrice.amount)) {
                minPrice.amount = baggage.price.amount * segmentId.length;
                minPrice.currency = baggage.price.currency;
            }
        });
    });
    return {
        baggage: baggages,
        selected: isSelected(baggages[0], selectedServices),
        priceFrom: minPrice,
        servicesBySegments: getSelectedServicesBySegments(baggages, selectedServices, segments)
    };
};
export const getSelectedServicesBySegments = (baggages, selectedServices, segments, splitByServiceId) => {
    var _a, _b;
    const totalSegments = segments.length;
    const baggageMap = new Map(baggages.map(baggage => [baggage.id, baggage]));
    const segmentMap = new Map(segments.map(segment => [segment.id, segment]));
    const selectedSegmentIdSet = new Set();
    // Collect selected services, merging segmentIds and count
    const selectedServicesByPassengerMap = new Map();
    for (const selectedService of selectedServices) {
        const baggageService = baggageMap.get(selectedService.serviceId);
        if (!baggageService) {
            continue;
        }
        const key = `${splitByServiceId ? selectedService.serviceId : baggageService.rfics}/${selectedService.passengerId}/${selectedService.count}`;
        const existService = selectedServicesByPassengerMap.get(key);
        const serviceIds = new Set([selectedService.serviceId, ...((_a = existService === null || existService === void 0 ? void 0 : existService.serviceIds) !== null && _a !== void 0 ? _a : [])]);
        const segmentIds = new Set([...selectedService.segmentIds, ...((_b = existService === null || existService === void 0 ? void 0 : existService.segmentIds) !== null && _b !== void 0 ? _b : [])]);
        const count = Math.max(selectedService.count, (existService === null || existService === void 0 ? void 0 : existService.count) || 0);
        const isAllSegments = segmentIds.size === totalSegments;
        selectedServicesByPassengerMap.set(key, {
            count,
            isAllSegments,
            serviceIds: [...serviceIds].sort(),
            segmentIds: [...segmentIds].sort()
        });
        segmentIds.forEach(id => selectedSegmentIdSet.add(id));
    }
    const selectedServicesMap = new Map();
    for (const [serviceKey, selectedService] of selectedServicesByPassengerMap.entries()) {
        const segmentIds = selectedService.segmentIds;
        const key = `${serviceKey.split('/')[0]}/${segmentIds.join('/')}`;
        const existing = selectedServicesMap.get(key);
        if (existing) {
            existing.count += selectedService.count;
        }
        else {
            selectedServicesMap.set(key, {
                count: selectedService.count,
                directions: segmentIds
                    .map(id => segmentMap.get(id))
                    .filter((segment) => segment !== undefined)
                    .map(segment => ({
                    departure: { iata: segment.departure.airport.iata },
                    arrival: { iata: segment.arrival.airport.iata }
                })),
                allSegments: selectedService.isAllSegments,
                service: baggageMap.get(selectedService.serviceIds[0])
            });
        }
    }
    const selectedBaggageServices = [...selectedServicesMap.values()];
    // Check if all services should be marked as "all segments"
    if (selectedSegmentIdSet.size === totalSegments && selectedBaggageServices.length) {
        const firstService = selectedBaggageServices[0];
        const allMatch = selectedBaggageServices.every(service => service.count === firstService.count && service.allSegments === firstService.allSegments);
        if (allMatch) {
            return selectedBaggageServices.map(service => (Object.assign(Object.assign({}, service), { allSegments: true })));
        }
    }
    return selectedBaggageServices;
};
export const getSegmentsIatasKey = (leftSegment, rightSegment, separator = ' – ') => {
    return [leftSegment.departure.airport.iata, rightSegment.arrival.airport.iata].join(separator);
};
export const isSelected = (baggage, selectedServices) => {
    return calcCount(baggage, selectedServices) > 0;
};
export const calcCount = (baggage, selectedServices) => {
    return selectedServices.filter(el => el.serviceId === baggage.id).reduce((acc, el) => acc + el.count, 0);
};
export const detectDirection = (baggage, selectedServices, order) => {
    const firstSegment = order.flight.segments[0];
    const lastSegment = order.flight.segments[order.flight.segments.length - 1];
    const allDirections = order === null || order === void 0 ? void 0 : order.travellers.map(traveller => {
        const services = selectedServices.filter(el => traveller.id === el.passengerId);
        if (services.length === 0) {
            return null;
        }
        return detectDirectionForTraveller(baggage, services, firstSegment, lastSegment);
    });
    const existRoundTrip = allDirections.some(direction => direction === BaggageDirection.RoundTrip);
    const existThere = allDirections.some(direction => direction === BaggageDirection.There);
    const existReturn = allDirections.some(direction => direction === BaggageDirection.Return);
    if (existRoundTrip) {
        return BaggageDirection.RoundTrip;
    }
    else if (existThere && existReturn) {
        return BaggageDirection.RoundTrip;
    }
    else if (existThere) {
        return BaggageDirection.There;
    }
    else if (existReturn) {
        return BaggageDirection.Return;
    }
    return null;
};
export const detectDirectionForTraveller = (baggage, selectedServices, firstSegment, lastSegment) => {
    const segmentIds = [];
    selectedServices
        .filter(service => baggage.id === service.serviceId)
        .forEach(el => el.segmentIds.forEach(segmentId => {
        segmentIds.push(segmentId);
    }));
    if (segmentIds.length === 0) {
        return null;
    }
    const thereDirection = segmentIds.includes(firstSegment.segment.id);
    let returnDirection = false;
    if (firstSegment.segment.id !== lastSegment.segment.id) {
        returnDirection = segmentIds.includes(lastSegment.segment.id);
    }
    if (thereDirection && returnDirection) {
        return BaggageDirection.RoundTrip;
    }
    else if (thereDirection) {
        return BaggageDirection.There;
    }
    else if (returnDirection) {
        return BaggageDirection.Return;
    }
    return null;
};
export const factorySelectedServices = (selectedServices) => {
    var _a, _b;
    const result = [];
    const addedKeys = new Map();
    for (const [passengerId, passengerSelectedServices] of Object.entries(selectedServices)) {
        for (const [serviceId, segments] of Object.entries(passengerSelectedServices)) {
            for (const [segmentId, selectedService] of Object.entries(segments)) {
                const segmentIds = (_a = selectedServices[passengerId][serviceId][segmentId]) === null || _a === void 0 ? void 0 : _a.segmentIds;
                const key = `${passengerId}-${serviceId}-${segmentIds.join('-')}`;
                if (!addedKeys.has(key)) {
                    result.push({
                        passengerId,
                        segmentIds: (_b = selectedServices[passengerId][serviceId][segmentId]) === null || _b === void 0 ? void 0 : _b.segmentIds,
                        serviceId,
                        count: selectedService.count
                    });
                    addedKeys.set(key, key);
                }
            }
        }
    }
    return result;
};
